export default __webpack_public_path__ + "static/media/payment_cancel.98f6ec1c.svg";